import { translations } from './translations.js';
import { logEvent } from './monitoring.js';

const reportedMissingKeys = new Set();

const flattenKeys = (input, prefix = '', acc = []) => {
  Object.entries(input || {}).forEach(([key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      flattenKeys(value, fullKey, acc);
      return;
    }
    acc.push(fullKey);
  });
  return acc;
};

const resolvePathValue = (obj, key) => {
  if (!obj) return undefined;
  if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
  if (!key.includes('.')) return undefined;

  return key.split('.').reduce((acc, part) => {
    if (acc && typeof acc === 'object' && Object.prototype.hasOwnProperty.call(acc, part)) {
      return acc[part];
    }
    return undefined;
  }, obj);
};

const findNestedByLeafKey = (obj, targetKey) => {
  if (!obj || typeof obj !== 'object') return undefined;
  if (Object.prototype.hasOwnProperty.call(obj, targetKey) && typeof obj[targetKey] === 'string') {
    return obj[targetKey];
  }

  for (const value of Object.values(obj)) {
    if (value && typeof value === 'object') {
      const found = findNestedByLeafKey(value, targetKey);
      if (found) return found;
    }
  }

  return undefined;
};

export const getTranslationCoverage = () => {
  const baseKeys = flattenKeys(translations.en || {});
  const missingByLanguage = {};

  Object.keys(translations).forEach((lang) => {
    if (lang === 'en') return;
    missingByLanguage[lang] = baseKeys.filter((key) => {
      const localeValue = resolvePathValue(translations[lang], key) || findNestedByLeafKey(translations[lang], key);
      return !localeValue;
    });
  });

  return { baseKeys, missingByLanguage };
};

export const getTranslationValue = (lang, key) => {
  const directValue = resolvePathValue(translations[lang], key) || findNestedByLeafKey(translations[lang], key);
  if (directValue) return directValue;

  const reportKey = `${lang}:${key}`;
  if (process.env.NODE_ENV !== 'production' && !reportedMissingKeys.has(reportKey)) {
    reportedMissingKeys.add(reportKey);
    logEvent('error', 'missing_translation', { lang, key });
  }

  if (process.env.NODE_ENV !== 'production') {
    const englishValue = resolvePathValue(translations.en, key) || findNestedByLeafKey(translations.en, key);
    if (englishValue) return englishValue;
  }

  return `[${lang}:${key}]`;
};
